import { Route, Routes } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import "./App.css";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

import SignIn from "./pages/signIn/signIn";
import SignUp from "./pages/signUp/signUp";
import ProtectedRoute from "./components/protectedRoute/protectedRoute";
import Leads from "./pages/leads/leads";
import ZoomCalls from "./pages/zoomCalls/zoomCalls";
import ComingSoon from "./pages/comingSoon/comingSoon";
import PageNotFound from "./pages/pageNotFound/pageNotFound";
import Teams from "./pages/teams/teams";
import Pipeline from "./pages/pipeline/pipeline";
import Matters from "./pages/matters/matters";
import Dashboard from "./pages/dashboard/dashboard";
import CalendarAppointments from "./pages/calendarAppointments/calendarAppointments";
import { AuthContext } from "./context/AuthContext/AuthContext";
import { useContext } from "react";

const protectedRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/leads/*", element: <Leads /> },
  { path: "/zoom-calls", element: <ZoomCalls /> },
  { path: "/matters/*", element: <Matters /> },
  { path: "/pipeline", element: <Pipeline /> },
  { path: "/calendar", element: <CalendarAppointments /> },
  { path: "/reports", element: <ComingSoon title="Reports Page" /> },
  { path: "/contacts", element: <ComingSoon title="Contacts Page" /> },
  { path: "/teams/*", element: <Teams />, role: 1 },
  { path: "/settings", element: <ComingSoon title="Settings Page" /> },
];

const App = () => {
  const { user } = useContext(AuthContext);
  return (
    <div id="toogleBoby" className="wrapper">
      <Routes>
        {/* Public */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />

        {/* Protected (role-aware) */}
        {protectedRoutes.map(({ path, element, role }, i) => {
          const canAccess = role === undefined || role === user?.role;
          return canAccess ? <Route key={i} path={path} element={<ProtectedRoute>{element}</ProtectedRoute>} /> : null;
        })}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
    // <PrimeReactProvider value={{ unstyled: false, ripple: true }}>
    //   <div id="toogleBoby" className="wrapper">
    //     <Routes>
    //       <Route path="/signin" element={<SignIn />} />
    //       <Route path="/signup" element={<SignUp />} />

    //       {protectedRoutes.map(({ path, element, role }, i) => role === user?.role && <Route key={i} path={path} element={<ProtectedRoute>{element}</ProtectedRoute>} />)}

    //       <Route path="*" element={<PageNotFound />} />
    //     </Routes>
    //   </div>
    // </PrimeReactProvider>
  );
};

export default App;
